export default __webpack_public_path__ + "static/media/1.8d332a07.jpg";